import { render, staticRenderFns } from "./activities-completion-card.vue?vue&type=template&id=0495ca12&scoped=true&"
import script from "./activities-completion-card.vue?vue&type=script&lang=js&"
export * from "./activities-completion-card.vue?vue&type=script&lang=js&"
import style0 from "./activities-completion-card.vue?vue&type=style&index=0&id=0495ca12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0495ca12",
  null
  
)

component.options.__file = "activities-completion-card.vue"
export default component.exports